import { render, staticRenderFns } from "./MessageDesc.vue?vue&type=template&id=262961ad&scoped=true"
import script from "./MessageDesc.vue?vue&type=script&lang=js"
export * from "./MessageDesc.vue?vue&type=script&lang=js"
import style0 from "./MessageDesc.vue?vue&type=style&index=0&id=262961ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262961ad",
  null
  
)

export default component.exports